import React from "react";
import bodyDTanTreatmentImg from "./../../../../../Images/Blog/Body_D-Tan_Treatment/Banner.png";

const BodyDTanTreatmentImg = () => {
  return (
    <div className="blogImg-content">
      <img
        src={bodyDTanTreatmentImg}
        alt="bodyDTanTreatmentImg"
        loading="lazy"
      />
    </div>
  );
};

export default BodyDTanTreatmentImg;
